// ----------------------------------------------------------------------

const account = {
  displayName: 'SoundChatRadio',
  email: 'demo@soundchat.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
